import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApi, useAuth } from '../../../hooks';

type PayloadProps = {
  user_id: string;
  diagnosis_ids: string[];
};

export const useUpdateUserDiagnoses = () => {
  const queryClient = useQueryClient();
  const { api } = useApi();
  const { userToken } = useAuth();

  const mutation = useMutation({
    mutationFn: async ({ payload }: { payload: PayloadProps }) => {
      return await api({
        route: '/private/user-diagnosis/',
        method: 'PATCH',
        token: userToken,
        payload,
      });
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['hc-user-diagnosis'],
      });
    },
  });

  return { mutation };
};
